import { useMemo } from "react";

import { getCurvableConnectors } from "./curvableConnector";
import { defaultCurveConfig } from "./curve";
import type { BoxedConnector, CurveConfig } from "./types";
import { useOptimalEdges } from "./useOptimalEdges";
import { usePaper } from "./usePaper";

type Props = {
  boxedConnectors: BoxedConnector[];
  options?: CurveConfig;
  movingSceneId?: number | string;
  debugPaper?: boolean;
};

export const useCurvableConnectors = ({
  boxedConnectors,
  options = defaultCurveConfig,
  movingSceneId,
  debugPaper = false,
}: Props) => {
  const paperCleanup = usePaper(debugPaper);

  // Calculate which edge of the scene card the connector should connect to, eg: from: "TOP", to: "LEFT"
  const optimalEdges = useOptimalEdges(boxedConnectors, movingSceneId, paperCleanup, options, debugPaper);

  return useMemo(
    () =>
      getCurvableConnectors({
        connectors: boxedConnectors,
        optimalEdges: optimalEdges,
        options,
      }),
    [boxedConnectors, optimalEdges, options],
  );
};
